import React from "react";

/**
 * Button réutilisable
 * Props :
 *  - children : texte ou contenu du bouton
 *  - onClick : callback
 *  - disabled : true/false
 *  - variant : "primary" | "outline" | "secondary"
 *  - className : styles additionnels
 *  - ...rest : autres props
 */
const Button = ({
  children,
  onClick,
  disabled = false,
  variant = "primary",
  className = "",
  ...rest
}) => {
  const baseClasses =
    "px-5 py-3 text-lg rounded font-medium transition-colors duration-200";

  let variantClasses = "";
  switch (variant) {
    case "primary":
      variantClasses =
        "bg-gold text-white hover:bg-gold-dark disabled:bg-gray-300 disabled:text-gray-600";
      break;
    case "outline":
      variantClasses =
        "border border-gold text-gold hover:bg-gold hover:text-white disabled:border-gray-300 disabled:text-gray-400";
      break;
    case "secondary":
      variantClasses =
        "bg-gray-100 text-gray-800 hover:bg-gray-200 disabled:bg-gray-300 disabled:text-gray-500";
      break;
    default:
      variantClasses =
        "bg-gold text-white hover:bg-gold-dark disabled:bg-gray-300 disabled:text-gray-600";
  }

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;